import React from 'react';
import { render } from 'react-dom';
import { hashHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import { Root } from './containers';
import configureStore from './store/configureStore';
import { loginUserSuccess } from './actions/auth';
import { isTokenValid } from './utils/helpers';

import './styles/main.css';

const store = configureStore();

const history = syncHistoryWithStore(hashHistory, store);

const token = localStorage.getItem(process.env.REACT_APP_TOKEN_NAME);

switch (process.env.REACT_APP_CVI) {
  case 'Pezinok':
    window.cviConfig = {
      cviCity: 'Samorin',
      cviCountry: 'Slovakia',
      eventPlace: 'X-Bionic Sphere, Samorin, Slovakia',
      eventDate: '9th June - 11th June 2022',
      deadlineDate: '31st May 2022',
      nominativeDate: '5th May 2022',
      supportEmail: 'info@cvislovakia.sk',
      cviUrl: 'http://cvislovakia.sk',
      guideFileName: 'guide_to_entry_system_pezinok.pdf',
    };
    break;
  case 'Bern':
    window.cviConfig = {
      cviCity: 'Bern',
      cviCountry: 'Switzerland',
      eventPlace: 'PostFinance Arena Bern, Mingerstrasse 12, 3014 Bern, Switzerland',
      eventDate: '15th July - 21st July 2024',
      deadlineDate: '1st July 2024',
      nominativeDate: '17th June 2024',
      supportEmail: 'entries@bern2024.ch',
      cviUrl: 'https://bern2024.ch',
      guideFileName: 'guide_to_entry_system_championship_bern.pdf',
    };
    break;
  case 'Brogel':
    window.cviConfig = {
      cviCity: 'Brogel',
      cviCountry: 'Belgium',
      eventPlace: 'Breugelhoeve M&M, Weyerstraat 1a, 3990 Peer',
      eventDate: '22nd April - 24th April 2022',
      deadlineDate: '31st March 2022',
      nominativeDate: '15th March 2022',
      supportEmail: 'michel.soenen@voltige.be',
      cviUrl: 'http://www.breugelhoevemm.be',
      guideFileName: 'guide_to_entry_system_belgium.pdf',
    };
    break;
  case 'Lier':
    window.cviConfig = {
      cviCity: 'Lier',
      cviCountry: 'Belgium',
      eventPlace: 'AZELHOF HORSE EVENTS, Aarschotsesteenweg 201 2500 Koningshooikt (Lier)',
      eventDate: '11th May – 14th May 2023',
      deadlineDate: '15th April 2023',
      nominativeDate: '-',
      supportEmail: 'michel.soenen@voltige.be',
      cviUrl: 'http://www.azelhof.be',
      guideFileName: 'guide_to_entry_system_belgium.pdf',
    };
    break;
  default:
}

if (isTokenValid(token)) {
  store.dispatch(loginUserSuccess(token));
}

render(<Root store={store} history={history} />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js